// Game constants and utility functions for MfersBeheaded

interface PowerUp {
  type: number;
  audio: string;
  name: string;
}

interface PowerUps {
  SUPER_POWER_UP: PowerUp;
}

interface Timing {
  BIT_FLIP_INTERVAL: number;
  SOUND_DELAY: number;
  ANIMATION_DELAY: number;
  MIN_AUTOPLAY_INTERVAL: number;
  DEFAULT_AUTOPLAY_INTERVAL: number;
}

interface Constants {
  WRONG_SOUND: string;
  GAME_STATE_NOT_YET_BEGUN: number;
  GAME_STATE_IN_PROGRESS: number;
  GAME_STATE_COMPLETE: number;
  N_MFERHEADS: number;
  N_DEAD_ZONE: number;
  BACKEND_URL: string;
  POWER_UPS: PowerUps;
  TIMING: Timing;
}

const CONSTANTS: Constants = {
    WRONG_SOUND: '/audio/mfersbeheaded/wrong_sound.mp3',
    GAME_STATE_NOT_YET_BEGUN: 0,
    GAME_STATE_IN_PROGRESS: 1,
    GAME_STATE_COMPLETE: 2,
    N_MFERHEADS: 6,
    N_DEAD_ZONE: 1000,
    BACKEND_URL: "https://pf2s6gyu6d.execute-api.us-west-2.amazonaws.com/default/writeGamePlay",
    //BACKEND_URL: "https://eol08mb249.execute-api.us-west-2.amazonaws.com/default/writeGameplayDev"
    POWER_UPS: {
        SUPER_POWER_UP: {
            type: 7,
            audio: '/audio/mfersbeheaded/voice/lobesy.mp3',
            name: 'Super Power Up'
        }
    },
    TIMING: {
        BIT_FLIP_INTERVAL: 3000,
        SOUND_DELAY: 300,
        ANIMATION_DELAY: 150,
        MIN_AUTOPLAY_INTERVAL: 100,
        DEFAULT_AUTOPLAY_INTERVAL: 500
    }
};

export function formatDate(dateString: string): string {
    const today = new Date();
    const date = new Date(dateString);

    const diffMs = today.getTime() - date.getTime(); // milliseconds difference
    const diffSeconds = diffMs / 1000;
    const diffMinutes = diffSeconds / 60;
    const diffHours = diffMinutes / 60;
    const diffDays = diffHours / 24;

    if (diffMinutes < 5) {
        return 'few minutes ago';
    } else if (diffHours < 1) {
        return 'last hour';
    } else if (diffHours < 6) {
        return 'a few hours ago';
    } else if (diffDays < 1) {
        return 'today';
    } else if (diffDays < 2) {
        return 'yesterday';
    } else if (diffDays < 7) {
        return `${Math.floor(diffDays)} days ago`;
    } else if (diffDays < 14) {
        return 'last week';
    } else if (diffDays < 30) {
        return `${Math.floor(diffDays / 7)} weeks ago`;
    } else if (diffDays < 60) {
        return 'last month';
    } else {
        // Return the actual date for anything older than 2 months
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    }
}

type BasednessResult = [string, string];

export function computeBasedness(totalScore: number, levelName: string): BasednessResult {
    if (levelName === "Let's F'ing Rawr") {
        if (totalScore > 2000) {
            return ["rawrizard", "/images/mfersbeheaded/tinydinos/charizard.png"];
        } else if (totalScore > 690) {
            return ["Noun Dino spartan", "/images/mfersbeheaded/tinydinos/nouns.png"];
        } else if (totalScore >= 450) {
            return ["Rainbow Dino", '/images/mfersbeheaded/tinydinos/rainbowDino.png'];
        } else if (totalScore >= 350) {
            return ["Mfer Dino", '/images/mfersbeheaded/tinydinos/mfer.png'];
        } else if (totalScore >= 200) {
            return ["Bat Dino", '/images/mfersbeheaded/tinydinos/bug.png'];
        } else {
            return ["Dino", '/images/mfersbeheaded/tinydinos/skater.png'];
        }
    }
    if (levelName === "Pixel Crush") {
        if (totalScore > 2000) {
            return ["king spartan", "/images/mfersbeheaded/naka/nakaking.png"];
        } else if (totalScore > 690) {
            return ["king spartan", "/images/mfersbeheaded/naka/nakaking.png"];
        } else if (totalScore >= 450) {
            return ["hoodie", '/images/mfersbeheaded/naka/naka10043.png'];
        } else if (totalScore >= 350) {
            return ["frog", '/images/mfersbeheaded/naka/naka6219.png'];
        } else if (totalScore >= 200) {
            return ["bot", '/images/mfersbeheaded/naka/naka1514.png'];
        } else {
            return ["migo", '/images/mfersbeheaded/naka/naka16327.png'];
        }
    }
    if (totalScore > 2000) {
        return ["alien", '/images/mfersbeheaded/fullbody/alien.png'];
    } else if (totalScore > 690) {
        return ["ape", '/images/mfersbeheaded/fullbody/ape.png'];
    } else if (totalScore >= 450) {
        return ["zombie", '/images/mfersbeheaded/fullbody/zombie.png'];
    } else if (totalScore >= 350) {
        return ["hoodie", '/images/mfersbeheaded/fullbody/hoodie.png'];
    } else if (totalScore >= 200) {
        return ["cowboy", '/images/mfersbeheaded/fullbody/cowboy.png'];
    } else {
        return ["mfer", '/images/mfersbeheaded/fullbody/mfer.png'];
    }
}

export default CONSTANTS;